export const COMPANY_NAME = "3DC FINANCE ONLINE"
export const COMPANY_NAME_FULL = "3DC FINANCE ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "3DC FINANCE ONLINE"
export const META_DESCRIPTION = "Welcome to 3DC FINANCE ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.3dc-finance.com"
export const ENABLE_OTHER_DEPOSIT = true
